module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Mindy_DeBruce.89186de7.webp";